import React, { Children, useEffect, useRef, useState } from "react";
import LeftArrowIcon from "@components/V3/Icons/LeftArrowIcon";
import RightArrowIcon from "@components/V3/Icons/RightArrowIcon";
import "./style.scss";

const Slider = ({ children, className = "", arrowClass = "", wrapperClass = "" }) => {
    const containerRef = useRef(null);
    const [scrollState, setScrollState] = useState(() => ({
        isOverflowing: false,
        canScrollBack: false,
        canScrollForward: true,
    }));

    const checkScrollState = () => {
        const container = containerRef.current;
        if (!container) return;
        const tolerance = 2;
        const isOverflow = container.scrollWidth > container.clientWidth;

        setScrollState({
            isOverflowing: isOverflow,
            canScrollBack: container.scrollLeft > tolerance,
            canScrollForward:
                container.scrollLeft + container.clientWidth < container.scrollWidth - tolerance,
        });
    };

    const handleScroll = (direction) => {
        const container = containerRef.current;
        if (!container) return;
        const scrollAmount = container.clientWidth;
        const newPosition =
            direction === "forward"
                ? Math.min(container.scrollLeft + scrollAmount, container.scrollWidth)
                : Math.max(container.scrollLeft - scrollAmount, 0);
        container.scrollTo({ left: newPosition, behavior: "smooth" });

        setTimeout(checkScrollState, 300);
    };

    /* eslint-disable react-you-might-not-need-an-effect/no-external-store-subscription, react-you-might-not-need-an-effect/no-initialize-state */
    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        checkScrollState();
        container.addEventListener("scroll", checkScrollState);
        window.addEventListener("resize", checkScrollState);

        return () => {
            container.removeEventListener("scroll", checkScrollState);
            window.removeEventListener("resize", checkScrollState);
        };
    }, []);
    /* eslint-enable react-you-might-not-need-an-effect/no-external-store-subscription, react-you-might-not-need-an-effect/no-initialize-state */
    useEffect(() => {
        checkScrollState();
    }, [Children.count(children)]);

    return (
        <div className={`slider ${wrapperClass} ${scrollState.canScrollBack ? "active" : ""}`}>
            {scrollState.canScrollBack && (
            <button
                className={`slider__arrow ${arrowClass} slider__arrow--left`}
                onClick={() => handleScroll("back")}
                aria-label="Scroll left"
                >
                <LeftArrowIcon />
            </button>
            )}
            <div ref={containerRef} className={`slider__container ${className}`}>
                {children}
            </div>
            {scrollState.canScrollForward && scrollState.isOverflowing && (
                <button
                    className={`slider__arrow ${arrowClass} slider__arrow--right`}
                    onClick={() => handleScroll("forward")}
                    aria-label="Scroll right"
                >
                    <RightArrowIcon />
                </button>
            )}
        </div>
    );
};

export default Slider;
